<template>
	<div class="wrapper-card-audit">
		<template v-if="loading">
			<div class="loading">
				<div class="">
					<div class="full-size-loader"></div>
				</div>
			</div>
		</template>
		<template v-else>
			<template v-if="hasError" >
				<div class="alert alert-danger" role="alert">
					{{ errorMsg }}
				</div>
			</template>
			<template v-else-if="isLoaded">
				<div class="result-audit">
					<template v-if="hasAudits">
						<!-- Card -->
						<div class="card"
							v-for="(audit) in audits"
							:key="`audit-${audit.id}`">
							<div class="card-header">
								<span v-html="$t(`${idPanel}.${audit?.event}.metadata`, {...audit, ...{user_name: audit?.user?.name, user_email: audit?.user?.email}})"></span>
							</div>
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th class="w-200px">{{ $t(`${idPanel}.list.attribute`) }}</th>
												<th>
													<div class="row">
														<div class="col-6">{{ $t(`${idPanel}.list.old`) }}</div>
														<div class="col-6">{{ $t(`${idPanel}.list.new`) }}</div>
													</div>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(modified, attribute, index) in audit.data"
												:key="`audit-${audit.id}-attribute-${attribute}`">
												<td>
													<strong>{{ $t(`${translatePrefix}.${attribute}`) }}</strong>
												</td>
												<td>
													<table>
														<tr>
															<td class="old">
																<span>{{ $t(`${translatePrefix}.${attribute}`) }}</span>
															</td>
															<td class="new">
																<span>{{ $t(`${translatePrefix}.${attribute}`) }}</span>
															</td>
														</tr>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="w-100 text-center alert alert-info" role="alert">
							{{ $t(`${idPanel}.unavailable`) }}
						</div>
					</template>
				</div>
			</template>
		</template>
	</div>
</template>


<script>
import ElementAuditMixin from '../mixins/ElementAuditMixin';

export default {
	name: 'CardAudit',
	mixins: [
		ElementAuditMixin
    ],
	props: {
		automaticLoad: {
			type: Boolean,
			default: true,
		},
		dispatchLoad: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			idPanel: this.panelId,
			loaded: false,
            loading: false,
            loadingError: null,
            audits: [],
		}
	},
	mounted() {
        if(this.automaticLoad){
            this.initialize();
        }
    },
	computed: {
		isLoaded() {
            return this.loaded;
        },
        hasError() {
            return !!this.loadingError;
        },
        errorMsg() {
            let defaultError = 'Erro';
            return this.loadingError ?
                (this.loadingError.error && this.loadingError.error.error ?
                    this.loadingError.error.error : (this.loadingError.error ? this.loadingError.error : defaultError)) : defaultError;
        },
        numAudits() {
			return this.audits.length;
		},
		hasAudits() {
			return this.numAudits > 0;
		}
	},
	methods: {
		initialize() {
            if(this.isLoaded) return;
            return new Promise((resolve, reject) => {
                this.setLoaded(false);
                this.setLoading(true);
                resolve(this.loadData({url: this.url}));
            })
            .then((result) => {
                if(result) {
                    if (result.error) {
                        this.loadingError = result;
                    }else{
                        this.audits = result?.data ?? [];
                    }
                    this.setLoaded(true);
                }
            })
            .catch((error) => {
                this.showHttpError(error);
            })
            .finally(()=> {
                this.setLoading(false);
            })
        },
        reset() {

        },
        setLoaded(loaded = false) {
            this.loaded = loaded;
        },
        setLoading(loading = false) {
            this.loading = loading;
        },
        async loadData({ url, options={} }) {
            if(url) {
                return await this.$http.get(url, options)
                .then( res => {
                    let data = res.data ? res.data : res;
                    return data;
                })
                .catch( error => {
                    this.showHttpError(error);
                    return null;
                })
            }
            return Promise.resolve(null);
        },
	},
	watch: {
		dispatchLoad: {
            immediate: false,
            handler(value, oldValue){
                if(value) {
                    this.initialize();
                }else{
                    this.reset();
                }
            },
        }
	}
}
</script>

<style scoped lang="scss">
.wrapper-card-audit {
	.card {
		&:not(:last-child) {
			margin-bottom: 1rem;
		}

		.card-body {
			padding: .5rem;

			.table {
				margin-bottom: 0;

				> * > * > * {
					font-size: 90%;
				}

				tbody {
					td {
						padding: 0.5rem;
					}

					table {
						width: 100%;
						td {
							&.old {
								width: 50%;
								background: #ffe9e9;
							}
							&.new {
								width: 50%;
								background: #e9ffe9;
							}
						}
					}
				}
			}
		}
	}
}
</style>